import { fieldDateOptionsSchema, fieldOptionsSchema, fieldOptionsValueLabelSchema, fieldOptionsValueSchema, fieldTypeContextStackSchema, pickGroupRankOptionsSchema } from "@/lib/schema/question";
import z from "zod";

export enum AirtableFieldDateOptionsTimeFormat {
    "12 hours" = "h:mma",
    "24 hours" = "HH:mm"
}

export enum AirtableFieldDurationHoursOptions {
    'h:mm',
    'h:mm:ss',
    'h:mm:ss.s',
    'h:mm:ss.ss',
    'h:mm:ss.sss'
}

export type FieldDateOptions = z.infer<typeof fieldDateOptionsSchema>;

export type FieldOptions = z.infer<typeof fieldOptionsSchema>;

export type FieldOptionsValueLabel = z.infer<typeof fieldOptionsValueLabelSchema>

export type FieldOptionsValue = z.infer<typeof fieldOptionsValueSchema>

export type PickGroupRankOptions = z.infer<typeof pickGroupRankOptionsSchema>

export type FieldTypeContextStack = z.infer<typeof fieldTypeContextStackSchema>;